<template>
  <div>
    <template>
      <v-container>
        <v-row justify="center" align="center">
          <v-col v-if="mode === 'edit'" cols="12">
            <v-alert border="left" colored-border type="info" elevation="2">
              Die Aktualisierung der Veranstaltungsart beeinflusst alle
              bevorstehenden und noch nicht abgeschlossenen Veranstaltungen.
              Veranstaltungen in der Vergangenheit werden nicht angepasst.
            </v-alert>
          </v-col>
          <v-col cols="12">
            <Subheader
              icon="mdi-format-list-bulleted-type"
              title="Allgemein"
            ></Subheader>
            <div class="mt-7">
              <v-card>
                <v-card-text>
                  <v-container>
                    <v-row>
                      <v-col cols="12" sm="12" md="5">
                        <v-text-field
                          v-model.trim="eventTypeLocal.title"
                          :counter="32"
                          label="Bezeichnung"
                          required
                          :rules="[rules.required]"
                          outlined
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="12" md="4">
                        <v-text-field
                          v-model.trim="eventTypeLocal.shortTitle"
                          :counter="6"
                          label="Kurzbezeichnung"
                          required
                          :rules="[rules.required]"
                          outlined
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="12" md="3">
                        <v-text-field
                          v-model.number="eventTypeLocal.sortKey"
                          label="Sortierschlüssel"
                          prepend-inner-icon="mdi-sort-numeric-ascending"
                          type="number"
                          hint="Veranstaltungsarten werden aufsteigend nach ihrem Sortierschlüssel sortiert."
                          persistent-hint
                          required
                          :rules="[rules.required]"
                          outlined
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="12" md="12">
                        <v-textarea
                          v-model.trim="eventTypeLocal.description"
                          counter
                          clearable
                          no-resize
                          label="Beschreibung"
                          outlined
                          hide-details="auto"
                        ></v-textarea>
                      </v-col>
                      <v-col cols="12" sm="12" md="12">
                        Farbe wählen
                        <v-color-picker
                          v-model="eventTypeLocal.color"
                          :swatches="availableColors"
                          hide-inputs
                          hide-canvas
                          hide-sliders
                          show-swatches
                          width="1200"
                          swatches-max-height="150"
                        ></v-color-picker>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
              </v-card>
            </div>
          </v-col>
          <v-col cols="12">
            <Subheader
              icon="mdi-file-document-edit"
              title="Dokumentation in Dienstberichten"
            ></Subheader>
            <div class="mt-7">
              <v-card>
                <v-card-text>
                  <v-container>
                    <v-row>
                      <v-col cols="12" sm="12" md="6">
                        <v-select
                          v-model="eventTypeLocal.dutyType"
                          :items="dutyTypes"
                          label="Vorauswahl der
                        Dienstart für Erfassung der Veranstaltung"
                          item-text="title"
                          item-value="meta.id"
                          return-object
                          required
                          :rules="[rules.required]"
                          hide-details="auto"
                          outlined
                          ><template v-slot:item="data">
                            <v-list-item two-line>
                              <v-list-item-content>
                                <v-list-item-title>
                                  {{ data.item.title }}
                                </v-list-item-title>
                                <v-list-item-subtitle>
                                  {{ data.item.description }}
                                </v-list-item-subtitle>
                              </v-list-item-content>
                            </v-list-item>
                            <v-divider class="mt-2"></v-divider>
                          </template>
                        </v-select>
                      </v-col>
                      <v-col cols="12" sm="12" md="6">
                        <v-checkbox
                          v-model="eventTypeLocal.dutyReportReminder.isActive"
                          label="Erinnerung bei fehlender Dokumentation"
                          hint="Automatische Erinnerungen, wenn Veranstaltungen dieser Art nicht in einem Dienstbericht dokumentiert wurden. Es wird immer versucht zusätzlich auch eingetragene Organisatoren  zu benachrichtigen."
                          persistent-hint
                        ></v-checkbox>
                      </v-col>
                      <v-col
                        v-if="eventTypeLocal.dutyReportReminder.isActive"
                        cols="12"
                      >
                        <v-autocomplete
                          v-model="
                            eventTypeLocal.dutyReportReminder.notifyPersons
                          "
                          :items="membershipsListFiltered"
                          chips
                          small-chips
                          outlined
                          deletable-chips
                          label="Zu benachrichtigende Personen (neben Organisatoren)"
                          hint="Wenn keine Personen ausgewählt werden, werden die Standard-Empfänger aus der allgemeinen Konfiguration verwendet."
                          persistent-hint
                          item-text="displayName"
                          item-value="uid"
                          multiple
                          clearable
                          hide-details="auto"
                        >
                        </v-autocomplete>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
              </v-card>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </template>
  </div>
</template>

<script>
import Subheader from "@/components/_systemwide/Subheader.vue";
import { DUTY_MANAGEMENT, ADMIN } from "@/store/modules.js";
import { GET_REPORT_TYPES, GET_USER_LIST } from "@/store/action-types.js";
export default {
  name: "event-type-editor",
  props: {
    eventType: {},
    mode: {
      type: String,
      default: "new",
      required: true,
      validator: function (value) {
        return ["new", "edit"].indexOf(value) !== -1;
      },
    },
  },
  components: {
    Subheader,
  },
  data() {
    return {
      rules: {
        required: (value) => !!value || "Feld ist erforderlich.",
      },
      availableColors: [
        ["#F44336"],
        ["#E91E63"],
        ["#9C27B0"],
        ["#673AB7"],
        ["#3F51B5"],
        ["#2196F3"],
        ["#03A9F4"],
        ["#00BCD4"],
        ["#009688"],
        ["#4CAF50"],
        ["#8BC34A"],
        ["#CDDC39"],
        ["#FFEB3B"],
        ["#FFC107"],
        ["#FF9800"],
        ["#FF5722"],
        ["#795548"],
        ["#607D8B"],
        ["#9E9E9E"],
      ],
    };
  },
  model: {
    prop: "eventType",
    event: "eventTypeChange",
  },
  created() {
    this.initialized();
  },
  computed: {
    eventTypeLocal: {
      get: function () {
        // Ensure dutyReportReminder has default values for backward compatibility
        const eventType = this.eventType;
        if (eventType && !eventType.dutyReportReminder) {
          eventType.dutyReportReminder = {
            isActive: false,
            notifyPersons: [],
          };
        }
        return eventType;
      },
      set: function (value) {
        this.$emit("eventTypeChange", value);
      },
    },
    dutyTypes() {
      return this.$store.state.dutyManagement.dutyTypes.map((dutyType) => {
        return {
          title: dutyType.title,
          id: dutyType.meta.id,
        };
      });
    },
    memberships() {
      return this.$store.state.admin.membershipsPublic;
    },
    membershipsListFiltered() {
      const input = this.memberships;
      const groupItems = (arr) => {
        return arr.reduce((a, c) => {
          if (typeof a[c.group.title] === "undefined") a[c.group.title] = [];
          a[c.group.title] = [...a[c.group.title], c];
          return a;
        }, {});
      };
      const step1 = groupItems(input);
      const insertHeaders = (obj) => {
        return Object.entries(obj).reduce((a, [key, vals], i, d) => {
          let r = [
            {
              header: key,
            },
            ...vals,
          ];
          if (i < d.length - 1) {
            r = [
              ...r,
              {
                divider: true,
              },
            ];
          }
          a = [...a, ...r];
          return a;
        }, []);
      };
      const step2 = insertHeaders(step1);
      const step3 = step2
        .filter(
          (item) =>
            item.header || (item.user && item.user.displayName && item.user.uid)
        )
        .map((item) => {
          if (item.header) {
            return item;
          } else if (item.user && item.user.displayName && item.user.uid) {
            return {
              displayName: item.user.displayName || "",
              uid: item.user.uid,
            };
          } else {
            return {
              displayName: "",
              uid: "",
            };
          }
        });

      return step3;
    },
  },
  methods: {
    initialized() {
      this.$store.dispatch(`${DUTY_MANAGEMENT}${GET_REPORT_TYPES}`, {
        organizationId: this.$route.params.organizationId,
      });
      this.$store.dispatch(`${ADMIN}${GET_USER_LIST}`, {
        organizationId: this.$route.params.organizationId,
        queryIsFiltered: true,
        query: {
          type: "active",
        },
      });
    },
  },
};
</script>
